if (!customElements.get('faq-accordion')) {
  class FaqAccordion extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-faq-item]')];
      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-faq-trigger]');
        const panel = item.querySelector('[data-faq-panel]');
        this.syncAccessibility(item, trigger, panel);
        trigger?.addEventListener('click', () => this.toggle(item, trigger, panel));
      });

      this.onBlockSelect = this.handleBlockSelect.bind(this);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    toggle(item, trigger, panel, forceOpen = null) {
      const open = forceOpen ?? !item.hasAttribute('data-open');
      item.toggleAttribute('data-open', open);
      this.syncAccessibility(item, trigger, panel);
    }

    syncAccessibility(item, trigger, panel) {
      const open = item.hasAttribute('data-open');
      trigger?.setAttribute('aria-expanded', String(open));
      panel?.setAttribute('aria-hidden', String(!open));
      if (panel) panel.inert = !open;
    }

    handleBlockSelect(event) {
      const item = event.target.closest('[data-faq-item]');
      if (!item || !this.contains(item)) return;
      this.toggle(item, item.querySelector('[data-faq-trigger]'), item.querySelector('[data-faq-panel]'), true);
    }
  }

  customElements.define('faq-accordion', FaqAccordion);
}
